import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useJuice } from '../../context/JuiceContext';

interface MuteButtonProps {
  labeled?: boolean;
}

const MuteButton: React.FC<MuteButtonProps> = ({ labeled = false }) => {
  const { muted, toggleMuted } = useJuice();
  const [tip, setTip] = useState('');

  useEffect(() => {
    if (!tip) return undefined;
    const timer = window.setTimeout(() => setTip(''), 2200);
    return () => window.clearTimeout(timer);
  }, [tip]);

  const onToggle = () => {
    const turningOff = !muted;
    toggleMuted();
    setTip(turningOff ? 'Sound off' : 'Sound on');
  };

  return (
    <span className={`ss-mute-wrap${labeled ? ' is-labeled' : ''}`}>
      <button
        type="button"
        className={`ss-icon-btn ss-mute-btn${muted ? ' is-muted' : ' is-live'}${labeled ? ' is-wide' : ''}`}
        aria-pressed={muted}
        aria-label={muted ? 'Unmute sound effects' : 'Mute sound effects'}
        title={muted ? 'Sound is off' : 'Sound is on'}
        onClick={onToggle}
      >
        {muted ? (
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M4.5 9.5v5h3.2L12 18.8V5.2L7.7 9.5H4.5zm11.1-.4 1.4 1.4-2.1 2.1 2.1 2.1-1.4 1.4-2.1-2.1-2.1 2.1-1.4-1.4 2.1-2.1-2.1-2.1 1.4-1.4 2.1 2.1 2.1-2.1z"
            />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M4.5 9.5v5h3.2L12 18.8V5.2L7.7 9.5H4.5zm10.2.2c.8.8 1.3 1.9 1.3 3.3s-.5 2.5-1.3 3.3l1.5 1.5c1.3-1.2 2.1-3 2.1-4.8s-.8-3.6-2.1-4.8l-1.5 1.5zm2.9-2.9C19.3 8.4 20.5 10.6 20.5 13s-1.2 4.6-2.9 6.2l1.5 1.5C21.4 18.6 23 16 23 13s-1.6-5.6-4-7.7l-1.4 1.5z"
            />
          </svg>
        )}
        {labeled && <span className="ss-mute-label">{muted ? 'Muted' : 'Sound'}</span>}
      </button>
      {tip && typeof document !== 'undefined'
        ? createPortal(
            <span className="ss-mute-tip" role="status">
              {tip}
            </span>,
            document.body
          )
        : null}
    </span>
  );
};

export default MuteButton;
